/** Namespaces `providers` / `procedures` / `operatories` (Seiten-Extras) — befüllt während der Migration. */
export const masters = {
  de: {
    providers: {
      eyebrow: 'Stammdaten',
      pageDescription: 'Team und Kalenderzuordnungen verwalten',
      newProvider: 'Neuer Behandler',
      emptyTitle: 'Noch keine Behandler',
      emptyDescription: 'Lege Behandler an, um Termine zuweisen zu können.',
      emptyAction: 'Erste Person anlegen',
      role: 'Rolle',
      roleRequired: 'Rolle *',
      displaySpecialization: 'Anzeige-Spezialisierung',
      googleCalendar: 'Google-Kalender',
      linked: 'verknüpft',
      inactive: 'Inaktiv',
      roleDentist: 'Zahnarzt',
      roleHygienist: 'Zahnprophylaxe / Hygiene',
      nameField: 'Name *',
      emailField: 'E-Mail *',
      roleHint:
        'Bestimmt, welche Behandlungen abgedeckt werden können (z. B. Zahnreinigung → Hygiene, Beratung → Zahnarzt).',
      googleCalendarId: 'Google Calendar ID',
      googleCalendarIdPlaceholder: 'z. B. dra.garcia@seadent.es',
      googleCalendarIdHint:
        'Eigener Kalender. Service-Account muss Lesezugriff haben. Leer lassen, wenn Termine nur über das Admin gepflegt werden.',
      confirmDelete: 'Behandler „{{name}}“ wirklich löschen?',
      errorLoad: 'Behandler konnten nicht geladen werden',
      errorNameEmail: 'Name und E-Mail sind Pflicht',
      errorSave: 'Speichern fehlgeschlagen',
      errorDelete: 'Löschen fehlgeschlagen',
    },
    procedures: {
      eyebrow: 'Stammdaten',
      pageDescription: 'Leistungskatalog mit Dauer, Farbe und Rollenzuweisung',
      newProcedure: 'Neue Behandlung',
      editProcedure: 'Behandlung bearbeiten',
      emptyTitle: 'Noch keine Behandlungen',
      emptyDescription: 'Lege Behandlungen an, damit Patienten sie buchen können.',
      emptyAction: 'Erste Behandlung anlegen',
      colNameDe: 'Name (DE)',
      colKey: 'Key',
      colDuration: 'Dauer',
      colRequired: 'Benötigt',
      colColor: 'Farbe',
      colBookable: 'Buchbar',
      public: 'Öffentlich',
      internal: 'Intern',
      roleDentist: 'Zahnarzt',
      roleHygienist: 'Hygiene',
      keyLabelPrefix: 'Key (technischer Bezeichner, z. B. ',
      keyLabelSuffix: ')',
      keyPlaceholder: 'z. B. cleaning, whitening, botox',
      descriptionLabel: 'Beschreibung',
      durationLabel: 'Dauer (Minuten)',
      colorLabel: 'Farbe',
      colorAria: 'Farbe {{color}}',
      requiredRolesLabel: 'Benötigte Behandler-Rollen *',
      requiredRolesHint:
        'Diese Rolle(n) müssen zum Wunschtermin frei sein. Z. B. Zahnreinigung → Hygiene; Beratung/Behandlung → Zahnarzt.',
      bookableLabel: 'Auf seadent.es buchbar',
      errorLoad: 'Behandlungen konnten nicht geladen werden',
      errorNameRequired: 'Mindestens der deutsche Name ist Pflicht',
      errorRoleRequired: 'Mindestens eine benötigte Rolle muss ausgewählt sein',
      errorSave: 'Speichern fehlgeschlagen',
      errorDelete: 'Löschen fehlgeschlagen',
      confirmDelete: 'Behandlung „{{name}}“ wirklich löschen?',
    },
    operatories: {
      eyebrow: 'Stammdaten',
      pageDescription: 'Räume und ihre Ausstattung pflegen',
      newOperatory: 'Neuer Raum',
      editOperatory: 'Raum bearbeiten',
      emptyTitle: 'Noch keine Räume',
      emptyDescription: 'Lege Behandlungsräume an, um Termine räumlich zu planen.',
      emptyAction: 'Ersten Raum anlegen',
      description: 'Beschreibung',
      nameRequired: 'Name *',
      namePlaceholder: 'z. B. Behandlungszimmer 1',
      descriptionPlaceholder: 'z. B. Ausstattung, Lage, Hinweise',
      errorLoad: 'Behandlungsräume konnten nicht geladen werden',
      errorNameRequired: 'Name ist Pflicht',
      errorSave: 'Speichern fehlgeschlagen',
      errorDelete: 'Löschen fehlgeschlagen',
      confirmDelete: 'Behandlungsraum „{{name}}“ wirklich löschen?',
    },
  },
  es: {
    providers: {
      eyebrow: 'Datos maestros',
      pageDescription: 'Gestionar el equipo y las asignaciones de calendario',
      newProvider: 'Nuevo doctor',
      emptyTitle: 'Aún no hay doctores',
      emptyDescription: 'Cree doctores para poder asignar citas.',
      emptyAction: 'Crear la primera persona',
      role: 'Rol',
      roleRequired: 'Rol *',
      displaySpecialization: 'Especialización (visible)',
      googleCalendar: 'Google Calendar',
      linked: 'vinculado',
      inactive: 'Inactivo',
      roleDentist: 'Dentista',
      roleHygienist: 'Profilaxis dental / Higiene',
      nameField: 'Nombre *',
      emailField: 'Correo electrónico *',
      roleHint:
        'Determina qué tratamientos puede cubrir (p. ej., limpieza dental → Higiene, consulta → Dentista).',
      googleCalendarId: 'ID de Google Calendar',
      googleCalendarIdPlaceholder: 'p. ej., dra.garcia@seadent.es',
      googleCalendarIdHint:
        'Calendario propio. La cuenta de servicio debe tener acceso de lectura. Dejar vacío si las citas se gestionan solo desde el panel.',
      confirmDelete: '¿Eliminar realmente al doctor «{{name}}»?',
      errorLoad: 'No se pudieron cargar los doctores',
      errorNameEmail: 'El nombre y el correo electrónico son obligatorios',
      errorSave: 'Error al guardar',
      errorDelete: 'Error al eliminar',
    },
    procedures: {
      eyebrow: 'Datos maestros',
      pageDescription: 'Catálogo de tratamientos con duración, color y asignación de roles',
      newProcedure: 'Nuevo tratamiento',
      editProcedure: 'Editar tratamiento',
      emptyTitle: 'Aún no hay tratamientos',
      emptyDescription: 'Cree tratamientos para que los pacientes puedan reservarlos.',
      emptyAction: 'Crear el primer tratamiento',
      colNameDe: 'Nombre (DE)',
      colKey: 'Clave',
      colDuration: 'Duración',
      colRequired: 'Requerido',
      colColor: 'Color',
      colBookable: 'Reservable',
      public: 'Público',
      internal: 'Interno',
      roleDentist: 'Dentista',
      roleHygienist: 'Higiene',
      keyLabelPrefix: 'Clave (identificador técnico, p. ej. ',
      keyLabelSuffix: ')',
      keyPlaceholder: 'p. ej., cleaning, whitening, botox',
      descriptionLabel: 'Descripción',
      durationLabel: 'Duración (minutos)',
      colorLabel: 'Color',
      colorAria: 'Color {{color}}',
      requiredRolesLabel: 'Roles de doctor requeridos *',
      requiredRolesHint:
        'Este o estos roles deben estar disponibles en la fecha deseada. P. ej., limpieza dental → Higiene; consulta/tratamiento → Dentista.',
      bookableLabel: 'Reservable en seadent.es',
      errorLoad: 'No se pudieron cargar los tratamientos',
      errorNameRequired: 'Al menos el nombre en alemán es obligatorio',
      errorRoleRequired: 'Debe seleccionarse al menos un rol requerido',
      errorSave: 'Error al guardar',
      errorDelete: 'Error al eliminar',
      confirmDelete: '¿Eliminar realmente el tratamiento «{{name}}»?',
    },
    operatories: {
      eyebrow: 'Datos maestros',
      pageDescription: 'Gestionar las salas y su equipamiento',
      newOperatory: 'Nueva sala',
      editOperatory: 'Editar sala',
      emptyTitle: 'Aún no hay salas',
      emptyDescription: 'Cree salas de tratamiento para planificar las citas por ubicación.',
      emptyAction: 'Crear la primera sala',
      description: 'Descripción',
      nameRequired: 'Nombre *',
      namePlaceholder: 'p. ej., Sala de tratamiento 1',
      descriptionPlaceholder: 'p. ej., equipamiento, ubicación, observaciones',
      errorLoad: 'No se pudieron cargar las salas de tratamiento',
      errorNameRequired: 'El nombre es obligatorio',
      errorSave: 'Error al guardar',
      errorDelete: 'Error al eliminar',
      confirmDelete: '¿Eliminar realmente la sala de tratamiento «{{name}}»?',
    },
  },
};
